import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';

/**
 * 生成签名 ID
 * @param {*} reqBody - 请求体
 * @param {*} urlPath - URL 路径
 * @returns {string} - 签名后的 ID
 */
export const generateSignedId = (reqBody, urlPath) => {
    return generateSignedIdWithVisitorId(reqBody, urlPath, generateVisitorId());
}

/**
 * 生成签名 ID（带自定义 visitorId）
 * @param {*} reqBody - 请求体
 * @param {*} urlPath - URL 路径
 * @param {*} visitorId - 自定义 visitorId
 * @returns {string} - 签名后的 ID
 */
export const  generateSignedIdWithVisitorId = (reqBody, urlPath, visitorId) => {
    const vn = '/yida|' + visitorId;
    const pt1 = CryptoJS.MD5(reqBody).toString(CryptoJS.enc.Hex).toLowerCase();
    const vn1 = CryptoJS.MD5(vn).toString(CryptoJS.enc.Hex).toLowerCase();
    const ei = pt1.substring(2) + vn1 + pt1.substring(2) + vn1.substring(3) + urlPath;

    const sign = CryptoJS.MD5(ei).toString(CryptoJS.enc.Hex).toLowerCase();

    return sign;
}

/**
 * 生成 visitorId（基于 UUID 和 MD5）
 * @returns {string} - 生成的 visitorId
 */
export const generateVisitorId = () => {
    const uuid = uuidv4();
    const md5Uuid = CryptoJS.MD5(uuid).toString(CryptoJS.enc.Hex).toLowerCase();
    return md5Uuid;
}

// // 示例用法
// const reqBody = '{"key": "value"}'; // 替换为实际的请求体
// const urlPath = '/your/request/path'; // 替换为实际的 URL 路径

// // 使用默认 visitorId
// const signedIdDefault = generateSignedId(reqBody, urlPath);
// console.log('Generated Signed ID (Default visitorId):', signedIdDefault);

// // 使用自定义 visitorId
// const customVisitorId = 'your-custom-visitor-id'; // 替换为自定义的 visitorId
// const signedIdCustom = generateSignedIdWithVisitorId(reqBody, urlPath, customVisitorId);
// console.log('Generated Signed ID (Custom visitorId):', signedIdCustom);